import { Skeleton, Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme: Theme) => ({
  skeletonContainer: {
    position: 'relative',
    bottom: '12px',
    display: 'flex',
    justifyContent: 'center',
  },
  skeleton: {
    backgroundColor: theme?.palette?.mode === 'dark' ? 'grey' : 'lightgrey',
    height: '6em',
    margin: 0,
    width: '120px',
  },
  currentRange: {
    position: 'relative',
    bottom: '12px',
  },
}));
const SnapshotDateDisplay = ({ dateRanges }) => {
  const classes = useStyles();
  return (
    <>
      {dateRanges?.currentRange ? (
        <div className={classes.currentRange}>{dateRanges?.currentRange}</div>
      ) : (
        <div className={classes.skeletonContainer}>
          <Skeleton
            className={classes.skeleton}
            variant="rectangular"
            height={19.5}
          />
        </div>
      )}
    </>
  );
};

export default SnapshotDateDisplay;
